import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { isTV } from "../../../utils/platform";

const blur = !isTV && { backdropFilter: "blur(24.545454025268555px)" };

export const useStyles = createUseStyles((theme: ITheme) => ({
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing.space12,
    height: 96,
    padding: `${theme.spacing.space8}px ${theme.spacing.space16}px`,
    boxSizing: "border-box",
    cursor: "pointer",
    borderRadius: theme.spacing.space20,
    background: "rgba(255, 255, 255, 0.10)",
    ...blur,
    '&[data-open="true"]': {
      background: "rgba(255, 255, 255, 0.30)",
    },
  },
  buttonAvatar: {
    width: 60,
    height: 60,
    borderRadius: "50%",
    objectFit: "cover",
    fontSize: 36,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  caret: {
    width: 0,
    height: 0,
    borderLeft: "6px solid transparent",
    borderRight: "6px solid transparent",
    borderTop: "7px solid #FFFFFF",
  },
  selected: {
    outline: `2px solid ${theme.colors.Border4}`,
    outlineOffset: 2,
  },
  menu: {
    position: "fixed",
    right: "auto",
    bottom: "auto",
    margin: 0,
    padding: 0,
    border: "none",
    outline: "none",
    background: "transparent",
    overflow: "visible",
    "&::backdrop": {
      background: "transparent",
    },
  },
  menuContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
    width: 320,
    padding: theme.spacing.space12,
    boxSizing: "border-box",
    borderRadius: theme.spacing.space20,
    background: theme.colors.Background2,
    color: "#FFFFFF",
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space12,
    padding: `6px ${theme.spacing.space12}px`,
    borderRadius: 999,
    border: "2px solid transparent",
    cursor: "pointer",
    "&:hover": {
      borderColor: "rgba(255, 255, 255, 0.5)",
    },
  },
  itemSelected: {
    borderColor: "rgba(255, 255, 255, 0.5)",
  },
  itemAvatarWrapper: {
    position: "relative",
    flexShrink: 0,
  },
  lockBadge: {
    position: "absolute",
    right: -2,
    bottom: -2,
    width: 18,
    height: 18,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: "#2E3C4B",
  },
  lockGlyph: {
    color: theme.colors.TextDefault,
    fontSize: 11,
    lineHeight: 1,
  },
  itemAvatar: {
    flexShrink: 0,
    width: 48,
    height: 48,
    borderRadius: "50%",
    objectFit: "cover",
    fontSize: 28,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  itemIcon: {
    flexShrink: 0,
    width: 48,
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  itemName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));
